require('../modules/es6.parse-float');
module.exports = require('../modules/_core').parseFloat;


//////////////////
// WEBPACK FOOTER
// ./~/core-js/fn/parse-float.js
// module id = 230
// module chunks = 0